export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $getToken, $login } = useNuxtApp();

  if (import.meta.client) {
    if (to.path.startsWith("/portal")) {
      try {
        const accessToken = await $getToken();

        if (!accessToken) {
          console.warn("No access token found. Redirecting to login...");
          await $login();
          return navigateTo("/portal");
        }
      } catch (error) {
        console.error("Authentication error:", error);
        return abortNavigation();
      }
    }
  }
});
